// app/helpers/interactions/handlersTouch.js

export function makeTouchHandlers(ctx, mouseDown, mouseMove) {
  const handleTouchStart = (e) => {
    if (e.touches?.length === 2) {
      const [t1, t2] = [e.touches[0], e.touches[1]];
      const d = Math.hypot(t2.clientX - t1.clientX, t2.clientY - t1.clientY);
      ctx.setTouchStartDistance(d);
      ctx.setTouchStartZoom(ctx.zoom ?? 1);
      e.preventDefault?.();
    } else if (e.touches?.length === 1) {
      mouseDown(e);
    }
  };

  const handleTouchMove = (e) => {
    if (e.touches?.length === 2 && ctx.touchStartDistance) {
      const [t1, t2] = [e.touches[0], e.touches[1]];
      const d = Math.hypot(t2.clientX - t1.clientX, t2.clientY - t1.clientY);
      const s = d / ctx.touchStartDistance;
      ctx.onZoomChange(
        Math.max(0.1, Math.min(5, (ctx.touchStartZoom ?? 1) * s))
      );
      e.preventDefault?.();
    } else if (e.touches?.length === 1) {
      mouseMove(e);
    }
  };

  const handleTouchEnd = () => {
    ctx.setTouchStartDistance(null);
  };

  return { handleTouchStart, handleTouchMove, handleTouchEnd };
}
